import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import App from './App.jsx'

const NotFound = () => (
  <div className="container py-5">
    <h1 className="h4 mb-2">Page not found</h1>
    <p className="text-muted mb-0">The page you requested does not exist.</p>
  </div>
)

// Shared by the browser entry and the prerender entry so both render the same tree
export default function AppRoutes() {
  return (
    <Suspense fallback={<div className="container py-5 text-muted">Loading…</div>}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}
